<template>
  <div class="content__details">
    <TheModal />
    <h2>
      Ajoutez vos forfaits
    </h2>
    <div
      class="flex-fJstart-fAstart"
      @keyup="keyUpOnAddForfait($event)"
    >
      <label>
        Agences
        <select
          v-model="selectedAgence"
          type="text"
        >
          <option
            v-for="(agence, agenceKey) of agencesOptions"
            :key="`agence_${agenceKey}`"
            :value="agenceKey"
          >{{ agence.libelle_agence }}
          </option>
        </select>
      </label>
      <label>
        Zones
        <select
          v-model="selectedZone"
          class="superselect"
          type="text"
          placeholder="Zone"
        >
          <option
            v-for="(zoneOption, zoneKey) in zonesOptions"
            :key="'zone' + zoneKey"
            :value="zoneKey"
          >
            {{ zoneOption.libelle }}
          </option>
        </select>
      </label>
      <label
        v-if="categoriesOptions != null && categoriesOptions.length > 0"
      >
        Plan de vente
        <select
          v-model="selectedCategorie"
          class="superselect"
          type="text"
          placeholder="Plan de vente"
        >
          <option
            v-for="(categoryOption, categoryKey) in categoriesOptions"
            :key="'category' + categoryKey"
            :value="categoryKey"
          >{{ categoryOption.libelle_famille }}
          </option>
        </select>
      </label>
      <label>
        Tranches
        <TranchePicker ref="picker" />
      </label>
      <label>
        Montant
        <input
          v-model="currentMontant"
          type="text"
          placeholder="Montant"
        >
      </label>
      <label>
        Franco
        <input
          v-model="currentFranco"
          type="text"
          placeholder="Franco"
        >
      </label>
      <label>
        Libellé
        <input
          v-model="currentLibelle"
          type="text"
          placeholder="libellé"
        >
      </label>
      <label class="flex-fJend">
        <button
          @click="addForfait()"
        >AJOUTER
        </button>
      </label>
    </div>
    <h2>
      Forfaits transport existants
    </h2>
    <template v-if="forfaitsTransport !== null">

      <p class="forfait__agence flex-fJstart-fAcenter">
        <Icon
          name="home"
        />
        <span>Valeurs appliquées par défaut ...</span>
      </p>
      <FraisTransportAgence
        :agence="forfaitsTransport.sans_agence"
      />
      <div
        v-for="(agence, agenceKey) of forfaitsTransport.agences"
        :key="'agence' + agenceKey"
        class="forfait"
      >
        <p class="forfait__agence flex-fJstart-fAcenter">
          <Icon
            name="home"
          />
          <span>{{ agence.label }}</span>
        </p>
        <FraisTransportAgence
          :agence="agence"
        />
      </div>
    </template>
    <p v-else>
      Pas de forfait existant
    </p>
  </div>
</template>

<script>
import Icon from './atoms/Icon'
import TheModal from './modal/TheModal.vue'
import FraisTransportAgence from './atoms/FraisTransportAgence.vue'
import TranchePicker from './atoms/pickers/TrancheForfaitTransportPicker'
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {
    Icon,
    TranchePicker,
    TheModal,
    FraisTransportAgence
  },
  data() {
    return {
      selectedAgence: null,
      selectedZone: null,
      selectedCategorie: null,
      currentMontant: null,
      currentFranco: null,
      currentLibelle: null
    }
  },
  computed: {
    ...mapGetters([
      'forfaitsTransport',
      'currentForfaitTransport',
      'agencesOptions',
      'zonesOptions',
      'categoriesOptions',
      'tranchesOptions',
      'trancheSelected'
    ])
  },
  created() {
    this.initForfaitsTransport()
    this.getAgences()
  },
  methods: {
    ...mapActions([
      'initForfaitsTransport',
      'getAgences'
    ]),
    clearCriteres() {
      this.selectedAgence = null
      this.selectedZone = null
      this.selectedCategorie = null
      this.currentMontant = null
      this.currentFranco = null
      this.currentLibelle = null
      this.$refs.picker.setTranche(null)
    },
    forfaitValid() {
      let response = true
      if (this.selectedCategorie !== null && this.selectedZone === null) {
        Vue.toasted.show('Forfait non valide : la zone est obligatoire si un plan de vente a été saisi').goAway(1500)
        response = false
      } else if (this.trancheSelected === null) {
        Vue.toasted.show('Forfait non valide : la tranche est obligatoire').goAway(1500)
        response = false
      } else if (this.currentMontant === null) {
        Vue.toasted.show('Forfait non valide : le montant est obligatoire').goAway(1500)
        response = false
      } else if (this.currentLibelle === null) {
        Vue.toasted.show('Forfait non valide : le libellé est obligatoire').goAway(1500)
        response = false
      }
      return response
    },
    forfaitExistant() {
      let response = false
      let codeAgence = null
      if (this.selectedAgence !== null) {
        codeAgence = this.agencesOptions[this.selectedAgence]['code_agence']
      }
      let codeZone = null
      if (this.selectedZone !== null) {
        codeZone = this.zonesOptions[this.selectedZone]['id']
      }
      let codeCategorie = null
      if (this.selectedCategorie !== null) {
        codeCategorie = this.categoriesOptions[this.selectedCategorie]['code_famille']
      }

      if (this.forfaitsTransport !== null && this.forfaitsTransport['agences'][codeAgence] !== undefined) {
        if (codeAgence === null) {
          if (this.forfaitsTransport['agences'][this.trancheSelected.id] !== undefined) {
            response = true
          }
        } else {
          if (codeZone === null) {
            if (this.forfaitsTransport['agences'][codeAgence]['tranches'][this.trancheSelected.id] !== undefined) {
              response = true
            }
          } else {
            if (this.forfaitsTransport['agences'][codeAgence]['zones'][codeZone] !== undefined) {
              if (codeCategorie === null) {
                if (this.forfaitsTransport['agences'][codeAgence]['zones'][codeZone]['tranches'][this.trancheSelected.id] !== undefined) {
                  response = true
                }
              } else {
                if (this.forfaitsTransport['agences'][codeAgence]['zones'][codeZone]['categories'][codeCategorie] !== undefined
                  && this.forfaitsTransport['agences'][codeAgence]['zones'][codeZone]['categories'][codeCategorie]['tranches'][this.trancheSelected.id] !== undefined) {
                    response = true
                  }
              }
            }
          }
        }
      }
      return response
    },
    addForfait() {
      if (!this.forfaitValid()) {
        //Toasted in forfaitValid method
      } else if (this.forfaitExistant()) {
        Vue.toasted.show('Forfait déjà existant').goAway(1500)
      } else {
        const agenceProperty = {
          propName: 'agence',
          property: this.agencesOptions[this.selectedAgence]
        }
        this.$store.dispatch('setForfaitProperty', agenceProperty)

        const zoneProperty = {
          propName: 'zone',
          property: this.zonesOptions[this.selectedZone]
        }
        this.$store.dispatch('setForfaitProperty', zoneProperty)

        const categorieProperty = {
          propName: 'categorie',
          property: this.categoriesOptions[this.selectedCategorie]
        }
        this.$store.dispatch('setForfaitProperty', categorieProperty)

        const montantProperty = {
          propName: 'montant',
          property: this.currentMontant
        }
        this.$store.dispatch('setForfaitProperty', montantProperty)

        const francoProperty = {
          propName: 'franco',
          property: this.currentFranco
        }
        this.$store.dispatch('setForfaitProperty', francoProperty)

        const libelleProperty = {
          propName: 'libelle',
          property: this.currentLibelle
        }
        this.$store.dispatch('setForfaitProperty', libelleProperty)

        this.$store.dispatch('createForfaitTransport')

        this.clearCriteres()
      }
    },
    keyUpOnAddForfait(e) {
      if (typeof e !== 'undefined' && e.keyCode === 13) {
        this.addForfait()
      }
    }
  }
}
</script>

<style scoped>
h2 {
  margin: 20px 0;
}

.content__details label {
  flex-direction: column;
  text-transform: uppercase;
  height: 46px;
}

.content__details .ui-icon,
.content__details .ui-icon:hover {
  position: absolute;
  top: 1px;
  right: 1px;
  width: 16px;
  height: 16px;
  margin: 0;
  background-color: #ffffff;
  border: 6px solid #ffffff;
  outline: 0 none;
}

.content__details label:last-child {
  align-items: flex-start;
}

div + h2 {
  margin-top: 50px;
}

p {
  margin: 0;
  padding: 6px;
}
p > span {
  display: inline-flex;
  height: 16px;
  margin-left: 6px;
  font-size: 14px;
  font-weight: 400;
}
p.forfait__agence {
  background-color: #f1f1f1;
}
</style>
